import React from "react";

function Shirt() {
  return (
    <>
      <path
        d="m 401.19238,515.59896 c -3.11,2.11 -6.26,4.14 -9.46,6.12 -32.79921,20.22017 -69.76195,32.728 -108.1,36.58 -3.3,0.33 -6.63,0.6 -10,0.81 -0.82,0.05 -1.65,0.1 -2.47,0.13 -4.48667,0.24 -8.99667,0.36 -13.53,0.36 -4,0 -7.96333,-0.0933 -11.89,-0.28 l -1.33,-0.07 c -3.75,-0.17 -7.48,-0.44 -11.17,-0.79 l -1.17,-0.12 c -0.88,-0.08 -1.75,-0.17 -2.62,-0.27 -3.58,-0.39333 -7.13333,-0.86 -10.66,-1.4 l -3.1,-0.49 -0.68,-0.12 c -1.17,-0.19 -2.33,-0.39 -3.49,-0.61 -2.14,-0.39 -4.27,-0.8 -6.39,-1.25 -29.77023,-6.20319 -58.1867,-17.69509 -83.9,-33.93 -3.58,-2.26 -7.1,-4.59333 -10.56,-7 l -1,-0.73 c 14.45,-20 33.78,-36.8 59.87,-49.21 0.36,-0.17 0.75,-0.33 1.19,-0.51 l 0.34,-0.14 v 0 c 0.34,-0.13 0.69,-0.28 1.07,-0.41 1.7,-0.62 3.77,-1.26 6.09,-1.95 l 2.09,-0.61 2.19,-0.62 1.13,-0.32 1.07,-0.29 v 0 l 0.61,-0.18 0.62,-0.17 c 3.53,-1 7.26,-2 10.9,-3.11 l 43.34,43.23 12.45,-4.36 v 0 l 6.22,-2.16 v 0 l 0.6,-0.21 v 0 l 8.49,6.69 42.4,-18.9 8.30457,-13.72237 -0.56763,8.51441 8.97339,-11.84441 c -14.61831,0.63762 -1.41288,-2.70814 -1.27288,-2.62814 1.93712,-1.08814 18.49255,5.86051 21.88255,7.77051 23.25,13.05 40.49,29.4 53.53,48.2 z"
        style={{ fill: "#c5e8fc" }}
      />
      <path
        d="m 259.49238,501.47896 -21.92,29.72 -18.78,25.47 -3.1,-0.49 -0.68,-0.12 c -1.17,-0.19 -2.33,-0.39 -3.49,-0.61 -2.14,-0.39 -4.27,-0.8 -6.39,-1.25 l -33.71,-90.05 a 5.87,5.87 0 0 1 -0.38,-1.51 v 0 c 0.34,-0.13 0.7,-0.27 1.08,-0.4 1.7,-0.62 3.77,-1.26 6.09,-1.95 l 2.09,-0.61 2.19,-0.62 1.13,-0.32 1.08,-0.3 0.61,-0.17 0.62,-0.17 c 3.53,-1 7.26,-2 10.9,-3.11 l 43.34,43.22 12.46,-4.32 2.53,2.8 0.21,0.23 v 0 z"
        style={{ fill: "#accedd" }}
      />
      <path
        d="m 268.63238,538.45896 2.55,20.78 q -6.75,0.36 -13.55,0.36 -6,0 -11.89,-0.28 l -1.33,-0.07 3.51,-21.48 -10.35,-6.57 -5.54,-3.51 0.2,-0.27 23.15,-30.49 v 0 l 4.1,-5.4 27,36.17 z"
        style={{ fill: "#27273d" }}
      />
      <path
        d="m 208.73238,443.40896 -20.75,9.88 a 5.76,5.76 0 0 0 -2.91,7.24 l 28.61,75.55 a 6.3,6.3 0 0 0 10.95,1.52 l 34.41,-46.1 c 0,0 -33.2,-36.48 -43.76,-47 a 5.75,5.75 0 0 0 -6.55,-1.09 z"
        style={{ fill: "#ffffff" }}
      />
      <path
        d="m 303.24238,444.51896 c -10.56,10.52 -43.76,47 -43.76,47 l 34.41,46.08 a 6.3,6.3 0 0 0 10.94,-1.54 l 28.62,-75.55 a 5.76,5.76 0 0 0 -2.92,-7.24 l -20.75,-9.88 a 5.75,5.75 0 0 0 -6.54,1.13 z"
        style={{ fill: "#ffffff" }}
      />
    </>
  );
}

export default Shirt;
